import axios from 'axios'
import { server } from '../config/config-prod'

export const api = axios.create({
    baseURL: server.serverUrl
})
